/**
 * Cart Drawer Recommendations
 * Carrega produtos de uma coleção em ordem aleatória
 */
(function () {
  const MAX_PRODUCTS = 6;
  let loaded = false;

  /* ── helpers ─────────────────────────────────────────── */

  function getElements() {
    return {
      container: document.getElementById('CartDrawer-Recommendations'),
      list: document.getElementById('CartDrawer-RecommendationsList'),
    };
  }

  function getCollectionHandle() {
    const { container } = getElements();
    return container?.dataset?.collection || '';
  }

  function getCartVariantIds() {
    const inputs = document.querySelectorAll('input[data-quantity-variant-id]');
    const ids = new Set();
    inputs.forEach((i) => ids.add(Number(i.dataset.quantityVariantId)));
    return ids;
  }

  function formatMoney(value) {
    // /products.json retorna preço em reais (string ou number), não em centavos
    const num = typeof value === 'string' ? parseFloat(value) : value;
    return num.toFixed(2).replace('.', ',');
  }

  function shuffle(array) {
    const arr = array.slice();
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function buildCard(product) {
    const variant = product.variants[0];

    // Resolve URL da imagem sem manipular o sufixo (deixa Shopify servir como está)
    let imgSrc = '';
    if (product.featured_image) {
      imgSrc = product.featured_image;
    } else if (product.images && product.images.length > 0) {
      const first = product.images[0];
      imgSrc = typeof first === 'string' ? first : (first.src || '');
    }

    // Garante protocolo
    if (imgSrc && imgSrc.startsWith('//')) {
      imgSrc = 'https:' + imgSrc;
    }

    const comparePrice =
      variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
        ? `<s style="font-weight:400;opacity:.55;font-size:12px;margin-right:4px">${formatMoney(variant.compare_at_price)}</s>`
        : '';

    const imgHtml = imgSrc
      ? `<img src="${imgSrc}" alt="${product.title}" loading="lazy" onerror="this.style.display='none'">`
      : '<div style="aspect-ratio:1/1;background:#f0f0f0;border-radius:6px;"></div>';

    return `
      <div class="mini-cart-recs-card">
        <a href="${product.url}">
          ${imgHtml}
          <p class="mini-cart-recs-title">${product.title}</p>
        </a>
        <p class="mini-cart-recs-price">${comparePrice}${formatMoney(variant.price)}</p>
        <div class="mini-cart-recs-form">
          <button
            type="button"
            class="mini-cart-recs-btn"
            data-variant-id="${variant.id}"
            ${variant.available ? '' : 'disabled'}
          >
            ${variant.available ? 'Adicionar' : 'Esgotado'}
          </button>
        </div>
      </div>`;
  }

  function showSkeletons(count) {
    const { container, list } = getElements();
    if (!list || !container) return;
    list.innerHTML = Array.from({ length: count }, () => '<div class="mini-cart-recs-skeleton"></div>').join('');
    container.hidden = false;
  }

  /* ── fetch & render ──────────────────────────────────── */

  function fetchPage(handle, page) {
    return fetch(`/collections/${handle}/products.json?limit=50&page=${page}`)
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .catch(() => ({ products: [] }));
  }

  function fetchAndRender() {
    if (loaded) return;
    const handle = getCollectionHandle();
    if (!handle) return;

    loaded = true;
    showSkeletons(3);

    // Busca 3 páginas em paralelo para um pool maior de produtos
    Promise.all([fetchPage(handle, 1), fetchPage(handle, 2), fetchPage(handle, 3)])
      .then((pages) => {
        const all = pages.flatMap((p) => p.products || []);
        const { container, list } = getElements();
        if (!list || !container) return;

        if (!all.length) {
          container.hidden = true;
          return;
        }

        const cartIds = getCartVariantIds();
        const available = all.filter((p) => {
          const v = p.variants && p.variants[0];
          if (!v) return false;
          if (cartIds.has(v.id)) return false;
          return true;
        });

        if (!available.length) {
          container.hidden = true;
          return;
        }

        const shuffled = shuffle(available).slice(0, MAX_PRODUCTS);
        list.innerHTML = shuffled.map(buildCard).join('');
        container.hidden = false;
        bindAddButtons();
      })
      .catch((err) => {
        console.warn('[cart-drawer-recs]', err);
        const { container } = getElements();
        if (container) container.hidden = true;
      });
  }

  /* ── add to cart ─────────────────────────────────────── */

  function bindAddButtons() {
    const { list } = getElements();
    if (!list) return;
    list.querySelectorAll('.mini-cart-recs-btn[data-variant-id]').forEach((btn) => {
      btn.addEventListener('click', handleAdd);
    });
  }

  function handleAdd(e) {
    const btn = e.currentTarget;
    if (btn.disabled) return;

    const variantId = btn.dataset.variantId;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(() => refreshCartDrawer())
      .then(() => {
        const card = btn.closest('.mini-cart-recs-card');
        if (card) {
          card.style.transition = 'opacity .25s ease, transform .25s ease';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.9)';
          setTimeout(() => card.remove(), 260);
        }
      })
      .catch((err) => {
        console.error('[cart-drawer-recs] add error', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  /* ── refresh drawer ──────────────────────────────────── */

  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then((r) => r.json())
      .then((sections) => {
        const drawerHTML = new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('#CartDrawer');

        if (drawerHTML) {
          const currentDrawer = document.getElementById('CartDrawer');
          const mainContent = currentDrawer.querySelector('.drawer__main-content-column');
          const newMainContent = drawerHTML.querySelector('.drawer__main-content-column');
          if (mainContent && newMainContent) {
            mainContent.innerHTML = newMainContent.innerHTML;
          }
        }

        const bubbleSection = document.getElementById('cart-icon-bubble');
        if (bubbleSection && sections['cart-icon-bubble']) {
          const newBubble = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section');
          if (newBubble) {
            bubbleSection.innerHTML = newBubble.innerHTML;
          }
        }
      });
  }

  /* ── inicialização robusta ───────────────────────────── */

  // Detecta clique no ícone do carrinho ou em botões de adicionar
  function attachTriggers() {
    // Quando o ícone do carrinho é clicado
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      cartIcon.addEventListener('click', () => {
        loaded = false;
        setTimeout(fetchAndRender, 100);
      });
    }

    // Observa quando o drawer fica ativo (classe "active")
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.attributeName === 'class' && drawer.classList.contains('active')) {
            loaded = false;
            fetchAndRender();
          }
        }
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // Aguarda o DOM estar pronto e os custom elements carregados
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachTriggers);
    } else {
      attachTriggers();
    }
  }

  init();

  document.addEventListener('cart:refresh', () => {
    loaded = false;
    fetchAndRender();
  });
})();